import React, { FC, useContext } from 'react'

import { MatchesAnyOfFilter, MatchesAllOfFilter } from '../types'
import { FilterType } from '../enums'
import './tagged-input-filter-builder.scss'

import { EditableViewContext } from '@pushly/aqe/lib/components/hoc/editable-view/editable-view-context'
import classnames from 'classnames'
import { Select, Space } from 'antd'

type TaggedInputFilterProps = {
    filter: MatchesAnyOfFilter | MatchesAllOfFilter
    onChange: (value: MatchesAnyOfFilter | MatchesAllOfFilter) => void
    nested?: boolean
}

export const TaggedInputFilter: FC<TaggedInputFilterProps> = ({ filter, onChange, nested }) => {
    const viewCtx = useContext(EditableViewContext)
    return (
        <Space.Compact className="tagged-input-filter-compact" size="middle">
            {!nested && (
                <Select<FilterType.MATCHES_ANY_OF | FilterType.MATCHES_ALL_OF>
                    className={classnames(viewCtx.modeClassName, 'tagged-input-filter-match-type-select')}
                    size="middle"
                    options={[
                        { value: FilterType.MATCHES_ANY_OF, label: 'matches any of' },
                        { value: FilterType.MATCHES_ALL_OF, label: 'matches all of' },
                    ]}
                    value={filter.filterType as FilterType.MATCHES_ANY_OF | FilterType.MATCHES_ALL_OF}
                    onChange={(v) => {
                        onChange({
                            ...filter,
                            filterType: v,
                        } as MatchesAllOfFilter | MatchesAnyOfFilter)
                    }}
                    showSearch={false}
                />
            )}
            <Select
                className={classnames(viewCtx.modeClassName, 'tagged-input-filter-select')}
                mode="tags"
                size="middle"
                tokenSeparators={[',']}
                onChange={(v) => {
                    const nextFilter = {
                        ...filter,
                        value: v,
                    }
                    onChange(nextFilter)
                }}
                open={false}
                value={filter.value}
            />
        </Space.Compact>
    )
}
